import { render, staticRenderFns } from "./LottieRender.vue?vue&type=template&id=1d8bb331"
import script from "./LottieRender.vue?vue&type=script&lang=js"
export * from "./LottieRender.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports